import { render, staticRenderFns } from "./HeadingImageCC.vue?vue&type=template&id=29273e24&"
import script from "./HeadingImageCC.vue?vue&type=script&lang=js&"
export * from "./HeadingImageCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports